import React, { useEffect } from 'react';
import classNames from 'classnames';
import styles from './assets/report-info.module.scss';
import { IReportPayroll } from 'src/types/reportPayroll';
import RoleLayout from 'src/components/layout/RoleLayout';
import { RouteComponentProps } from 'react-router';

export interface StateProps {
    reportPayroll: Partial<IReportPayroll> | null;
}

export interface DispatchProps {
    getData: (id: string | number) => void;
}

interface RouteParams {
    id: string;
}

export interface OwnProps extends RouteComponentProps<RouteParams> {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const ReportPayrollInfo: React.FunctionComponent<Props> = ({
    reportPayroll,
    getData,
    match: {
        params: { id },
    },
}: Props) => {
    useEffect(() => {
        if (id) {
            getData(id);
        }
        // eslint-disable-next-line
    }, [getData]);

    if (!reportPayroll) {
        return null;
    }
    //  const {  } = reportPayroll;
    return (
        <RoleLayout>
            <div></div>

            <div className={classNames(styles.infoWrap)}>
                <div className={classNames(styles.infoItems)}></div>

                <div></div>
            </div>
        </RoleLayout>
    );
};

export default ReportPayrollInfo;
